import { useNavigate, useLocation } from 'react-router-dom';

const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return {
    goTo: (path) => {
      navigate(path);
    },
    isPath: (path, equal) => {
      if (equal) {
        return location.pathname === path;
      }
      return location.pathname.startsWith(path);
    },
    currentLocation: location,
  };
};

export default useNavigation;
